import { Configuration } from 'src/app/models/configurators-2d/applications/fence/configuration';
import { FenceService } from 'src/app/services/configurators-2d/applications/fence.service';
import { ConfiguratorItem } from '../configurator-item';

export abstract class FenceConfiguratorItem extends ConfiguratorItem<Configuration, FenceService> {
  constructor(fenceService: FenceService) {
    super(fenceService);
  }
}
